import classNames from "classnames"
import PropTypes from "prop-types"
import React, { forwardRef } from "react"

const Button = forwardRef(function Button(
  {
    disabled,
    onClick,
    onMouseDown,
    children,
    icon,
    iconOnly = false,
    iconStyle = "kit",
    id,
    form,
    isLoading,
    small,
    title,
    type = "button",
    variant = "tertiary",
    fullWidth = false,
    rounded,
  },
  ref
) {
  const renderIcon = () => {
    if (!(icon ?? isLoading)) return

    const iconClass = isLoading ? "fa-spinner-third fa-spin" : icon
    const iconPrefix = isLoading ? "fa-solid" : `fa-${iconStyle}`

    return (
      <span>
        <i
          data-testid="button-icon"
          className={`${iconPrefix} ${
            isLoading ? "inline-block" : "inline"
          } ${iconClass}`}
        />
        {iconOnly || <span>&nbsp;&nbsp;</span>}
      </span>
    )
  }

  const buttonVariant = () => {
    let btnVariant = `btn-${variant}`

    if (small) {
      btnVariant = `${btnVariant} btn-sm flex`
    }

    if (iconOnly) {
      btnVariant = `${btnVariant} btn-icon-only`
    }
    return btnVariant
  }

  return (
    <button
      ref={ref}
      data-design-system="Button"
      id={id}
      type={type}
      form={form}
      title={title}
      aria-label={title}
      className={classNames(
        { "w-full": fullWidth, "rounded-full": rounded },
        buttonVariant(),
        "inline-flex items-center justify-center whitespace-nowrap text-center focus:outline-none focus:ring print:hidden"
      )}
      disabled={isLoading || disabled}
      onClick={onClick}
      onMouseDown={onMouseDown}
    >
      {renderIcon()}
      {iconOnly || children}
    </button>
  )
})

Button.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  children: PropTypes.node,
  form: PropTypes.string,
  icon: PropTypes.string,
  iconOnly: PropTypes.bool,
  iconStyle: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool,
  small: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "secondary-yellow",
    "danger",
    "tertiary",
    "ghost",
    "ghost-tertiary",
    "ghost-danger",
    "link",
    "quarternary",
  ]),
  fullWidth: PropTypes.bool,
  rounded: PropTypes.bool,
}

export default Button
